import Component from '@averyano/core/src/classes/Component';
import each from 'lodash/each';
import { setCookie, getCookie } from '../utils/cookie';
import { stringToBoolean } from '../utils/utils';

export default class MusicIcon extends Component {
	constructor() {
		super({
			element: '.nav__hero__music',
			elements: {
				on: '.nav__hero__music__icon--on',
				off: '.nav__hero__music__icon--off',
				audio: '#satie',
				source: 'source',
			},
		});

		const soundCookie = getCookie('sound');
		this.parameters = {
			fromDiscover: false,
			disabledDiscover: soundCookie ? stringToBoolean(soundCookie) : false,
		};

		this.isLoaded = null; // null no src, 0 src loading, 1 loaded
		this.isPlaying = false;

		this.createIcon();
		this.addEventListeners();
	}

	createIcon() {}

	checkParams() {
		return new Promise((resolve) => {
			if (this.parameters.fromDiscover) {
				// The idea is that when the user clicks the "Learn more" button the 1st time, it enables the music. However, if user scrolls back and disables the music, and then clicks on the "Learn more" again, it won't play the music anymore.
				this.parameters.disabledDiscover = true;
			}

			if (!this.isLoaded) {
				this.isLoaded = 0;
				this.elements.source.src = this.elements.source.dataset.audio;

				this.elements.audio.addEventListener('loadeddata', (_) => {
					this.isLoaded = 1;
					resolve();
				});

				this.elements.audio.load();
			} else if (this.isLoaded === 1) {
				// Already loaded
				resolve();
			}
		});
	}

	toggleState() {
		this.checkParams().then(() => {
			this.isPlaying = !this.isPlaying;

			if (this.isPlaying) {
				this.elements.on.style.visibility = 'visible';
				this.elements.off.style.visibility = 'hidden';
				this.elements.audio.play();
				setCookie('sound', true, 7);
			} else if (!this.isPlaying) {
				this.elements.on.style.visibility = 'hidden';
				this.elements.off.style.visibility = 'visible';
				this.elements.audio.pause();
				setCookie('sound', false, 7);
			}
		});
	}

	addEventListeners() {
		this.element.addEventListener('click', this.toggleState.bind(this));
	}
}
